<template>
  <div class="my-coupon">
    <div class="page-header">
      <div class="tab-list">
        <div class="tab-item" :class="{active: tab === 'valid'}" @click="changeTab($event, 'valid')">未使用({{valid.allCoupons.length}})</div>
        <div class="tab-item" :class="{active: tab === 'used'}" @click="changeTab($event, 'used')">已使用({{used.allCoupons.length}})</div>
        <div class="tab-item" :class="{active: tab === 'expiry'}" @click="changeTab($event, 'expiry')">已过期({{expiry.allCoupons.length}})</div>
      </div>
      <div class="exchange-coupon">
        <el-input class="exchange-coupon-input" :placeholder="'输入优惠码'" :value="couponCode" :maxlength="10" @input="changeCouponCode"/>
        <button class="exchange-btn s-btn btn-mini btn-blue" :disabled="couponCode.length < 6" @click="exchangeCoupon($event, couponCode)">兑换</button>
      </div>
    </div>
    <div class="page-body">
      <template v-if="currentPageCoupons.length">
        <div class="coupon-list">
          <coupon-item
            class="coupon-item"
            v-for="(coupon, index) in currentPageCoupons"
            :key="index"
            :coupon="coupon"
          ></coupon-item>
        </div>
        <div class="pagenation-box">
          <el-pagination class="pagenation" @current-change="changePage" v-if="showCouponsObj.allCoupons.length > showCouponsObj.pageSize"
              :current-page="showCouponsObj.page" :page-size="showCouponsObj.pageSize" layout="prev, pager, next" :total="showCouponsObj.allCoupons.length"></el-pagination>
        </div>
      </template>
      <div class="nodata-box" v-else>
        <img class="nodata-img" src="../../../assets/imgs/new-user/coupon-nodata.png" alt="">
        <div class="nodata-text">
          <span v-if="tab === 'valid'">暂无优惠券</span>
          <span v-else-if="tab === 'used'">暂无已使用优惠券</span>
          <span v-else-if="tab === 'expiry'">暂无已过期优惠券</span>
        </div>
        <div @click="openRechargeDialog" class="more-btn s-btn btn-blue" v-if="tab === 'valid'">获取更多优惠券</div>
      </div>
    </div>
  </div>
</template>

<script>
import sensorsdata from 'sa-sdk-javascript';
import couponService from '../../../services/coupon-service';
import utils from '../../../libs/utils';

import couponItem from './components/coupon-item';
import vueBus from '../../../libs/bus';

export default {
  components: {
    couponItem,
  },
  data() {
    return {
      couponCode: '',
      tab: 'valid',
      valid: {
        allCoupons: [],
        page: 1,
        pageSize: 10,
      },
      used: {
        allCoupons: [],
        page: 1,
        pageSize: 10,
      },
      expiry: {
        allCoupons: [],
        page: 1,
        pageSize: 10,
      },
      loading: false,
    };
  },
  computed: {
    // 当前的优惠卷对象
    showCouponsObj() {
      return this[this.tab];
    },

    // 当前页面显示的优惠卷list
    currentPageCoupons() {
      const couponObj = this.showCouponsObj;
      const allCoupons = couponObj.allCoupons;
      if (allCoupons.length > couponObj.pageSize) {
        const pageStartIndex = (couponObj.page - 1) * couponObj.pageSize;
        let pageEndIndex = couponObj.page * couponObj.pageSize;
        if (pageEndIndex > allCoupons.length) {
          pageEndIndex = allCoupons.length;
        }
        return allCoupons.slice(pageStartIndex, pageEndIndex);
      }
      return allCoupons;
    },

  },
  created() {
    this.startEventBus();
    this.getCoupons();
  },
  methods: {

    // 获取所有优惠券
    getCoupons() {
      this.loading = true;
      couponService.peerCouponBriefQuery().then((data) => {
        this.valid.allCoupons = data.peer_coupon_available;
        this.expiry.allCoupons = data.expiry_list;
        this.used.allCoupons = data.used_list;
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    changeTab(e, tab) {
      sensorsdata.quick('trackHeatMap', e.target);
      this.tab = tab;
      this[this.tab].page = 1;
    },
    // 修改优惠券码
    changeCouponCode(value) {
      value = value.replace(/\W/ig, '').replace(/_/ig, '');
      value = value.length > 10 ? value.substring(0, 10) : value;
      value = value.toUpperCase();
      this.couponCode = value;
    },
    // 优惠券兑换
    exchangeCoupon(e, couponCode) {
      sensorsdata.quick('trackHeatMap', e.target);
      couponService.couponExchange({
        code: couponCode,
      }).then(() => {
        utils.msg.success('兑换成功');
        this.tab = 'valid';
        this.couponCode = '';
        this.getCoupons();
      }).catch((e) => {
        if (e) console.log(e);
      });
    },
    changePage(page) {
      this[this.tab].page = page;
    },
    // 启动bus,用于监听充值成功后需要刷新优惠卷列表
    startEventBus() {
      vueBus.$on('recharge-success', () => {
        this.getCoupons();
      });
      this.$once('hook:beforeDestroy', () => {
        vueBus.$off('recharge-success');
      });
    },
    openRechargeDialog() {
      vueBus.$emit('open-recharge-dialog');
    },
  },
};
</script>

<style lang="less" scoped>
.my-coupon{
  padding: 0 24px;
  .page-header{
    border-bottom: 1px solid #F0F0F0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 62px;
    .tab-list{
      display: flex;
      height: 100%;
      padding: 0 20px;
      .tab-item{
        margin-right: 40px;
        height: 100%;
        flex-shrink: 0;
        color: #6F6F6F;
        font-size: 14px;
        position: relative;
        display: flex;
        align-items: center;
        cursor: pointer;
        &.active{
          color: #599FFF;
          font-weight: 600;
          &::after{
            content: "";
            position: absolute;
            left: 50%;
            bottom: 0;
            transform: translateX(-50%);
            width: 30px;
            height: 4px;
            background: #599FFF;
            border-radius: 1px;
          }
        }
      }
    }
    .exchange-coupon{
      width: 280px;
      height: 40px;
      position: relative;
      .exchange-coupon-input{
        /deep/ .el-input__inner{
          height: 40px;
          border: 1px solid #DEE2E6;
          border-radius: 2px;
        }
      }
      .exchange-btn{
        position: absolute;
        right: 8px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
  .page-body{
    padding: 20px;
    .coupon-list{
      margin-right: -32px;
      display: flex;
      flex-wrap: wrap;
      .coupon-item{
        margin-right: 32px;
        margin-bottom: 32px;
      }
    }
    .pagenation-box{
      display: flex;
      justify-content: center;
    }

    .nodata-box{
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 60px 0;
      .nodata-img{
        width: 200px;
        height: 120px;
      }
      .nodata-text{
        color: #91999F;
        font-size: 16px;
        margin-top: 8px;
      }
      .more-btn{
        margin-top: 16px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/user-children/MyCoupon.vue